import { Text, type TextProps } from '@frontend/components';

export type EmptyCellContentProps = TextProps;

export const EmptyCellContent = (
  props: EmptyCellContentProps,
): React.ReactElement => {
  return (
    <Text color={'feature.placeholder'} {...props}>
      --
    </Text>
  );
};
